import { Toastr } from 'components/global/Toastr'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'

const initialState = {
  fetching: false,
  additions_summary: [],
  earnings_summary: [],
  deductions_summary: [],
  outsourcing_provider_summary: [],
  payrun_summary: {
    agency_fees: {},
    total_amount: {},
    earnings: {},
    additions: {},
    deductions: {},
  },
  payrun_comparing: {},
  employment_types_summary: [],
  payment_types_summary: [],
  all_employees: 0,
  currency_type: '',
  total_amount: '',
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.PAYRUN_SUMMARY_VIEW_LOAD_FULFILLED: {
      return {
        ...state,
        ...action.payload.data.data,
        fetching: false,
      }
    }
    case actions.PAYRUN_SUMMARY_VIEW_LOAD_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.PAYRUN_SUMMARY_VIEW_LOAD_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }

    default:
      return state
  }
}
